import React, { useState, useContext } from 'react';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import ArrowLgButton from '../Global/ArrowLgButton';
//@ts-ignore
import * as styles from './product-specifications.module.css';
import { KontentStringValue, KontentMedia } from '../../../types/KontentProps';
import { LazyMotion, domAnimation, m, AnimatePresence } from 'framer-motion';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import {
    optimizeKontentImageUrl,
    imagePreset,
    buildKontentSrcSet,
} from '../Global/DataUtils';

export interface Material {
    elements: {
        image: KontentMedia;
        material: KontentStringValue;
        material_feature: {
            value: {
                name: string;
            }[];
        };
        material_feature___german: {
            value: {
                name: string;
            }[];
        };
        name_for_display: KontentStringValue;
    };
}

interface Props {
    materials: Material[];
}

const Materials: React.FC<Props> = ({ materials }) => {
    const orange = '#f06623';
    const [currentMaterial, setCurrentMaterial] = useState(0);
    const numMaterials = materials.length;
    const breakpoints = useBreakpoint();
    const pageMetadata = useContext(PageMetadataContext);

    const handleClickPrev = () => {
        if (currentMaterial === 0) {
            setCurrentMaterial(numMaterials - 1);
        } else {
            setCurrentMaterial(currentMaterial - 1);
        }
    };

    const handleClickNext = () => {
        setCurrentMaterial(currentMaterial + 1);
    };

    const renderMaterial = (
        material: Material,
        idx: number,
        numMaterials: number
    ) => {
        if (breakpoints.md || idx === currentMaterial % numMaterials) {
            return (
                <LazyMotion features={domAnimation} key={'material' + idx}>
                    <AnimatePresence>
                        <m.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className={styles.material}
                        >
                            <div>
                                <img
                                    src={optimizeKontentImageUrl(
                                        material.elements.image?.value[0]
                                            ?.elements.file.value[0]?.url,
                                        imagePreset.card.mobile
                                    )}
                                    srcSet={buildKontentSrcSet(
                                        material.elements.image?.value[0]
                                            ?.elements.file.value[0]?.url,
                                        imagePreset.card.mobile.w,
                                        {
                                            fm: 'webp' as const,
                                            q: imagePreset.card.mobile.q,
                                        }
                                    )}
                                    sizes="200px"
                                    alt={
                                        material.elements.name_for_display
                                            ?.value || ''
                                    }
                                    loading="lazy"
                                />
                            </div>
                            <div className={styles.materialData}>
                                <h3 data-kontent-element-codename="name_for_display">
                                    {material.elements.name_for_display?.value}
                                </h3>
                                {
                                    <ul>
                                        {pageMetadata.preferredLanguage?.toLowerCase() !==
                                        'de-de'
                                            ? material.elements.material_feature
                                                  ?.value &&
                                              material.elements.material_feature.value.map(
                                                  (feature, idx) => (
                                                      <li key={idx}>
                                                          {feature.name}
                                                      </li>
                                                  )
                                              )
                                            : material.elements
                                                  .material_feature___german
                                                  ?.value &&
                                              material.elements.material_feature___german.value.map(
                                                  (feature, idx) => (
                                                      <li key={idx}>
                                                          {feature.name}
                                                      </li>
                                                  )
                                              )}
                                    </ul>
                                }
                                {!breakpoints.md && numMaterials > 1 && (
                                    <div className={styles.materialsControls}>
                                        <ArrowLgButton
                                            strokeColor={orange}
                                            direction="left"
                                            handleClick={handleClickPrev}
                                        />
                                        <ArrowLgButton
                                            strokeColor={orange}
                                            direction="right"
                                            handleClick={handleClickNext}
                                        />
                                    </div>
                                )}
                            </div>
                        </m.div>
                    </AnimatePresence>
                </LazyMotion>
            );
        }
    };

    return (
        <div className={styles.materials}>
            {materials &&
                materials.map((material: Material, idx: number) =>
                    renderMaterial(material, idx, numMaterials)
                )}
        </div>
    );
};

export default Materials;
